export default function DownloadLimit({ limit }: { limit: string }) {
  if (limit === "0") return null;
  return <em>The number of rows you can download is {limit}.</em>;
}
